/**
 * 受伤类型
 */

import {
  get,
  post,
  put,
  del
} from '@/util/request'
import download from "@/util/download";

/**
 * 根据Id查询
 * @param {*} Id
 * @returns
 */
export const SelectinjuryPartById = (Id) => {
  return get('/api/app/injuryPart?CurrentId=' + Id);
}

/**
 * 新增数据记录
 * @param {*} data
 * @returns
 */
export const AddinjuryPart = (data) => {
  return post('/api/app/injuryPart', data, {});
}

/**
 * 更新数据记录
 * @param {*} data
 * @returns
 */
export const ModifyinjuryPart = (data) => {
  return put('/api/app/injuryPart', data, {});
}

/**
 * 分页获取
 * @param {*} data
 * @returns
 */
export const GetDatainjuryPartList = (data) => {
  return post('/api/app/injuryPart/list', data, {});
}

/**
 * 删除记录
 * @param {*} id
 * @returns
 */
export const DeleteinjuryPart = (id) => {
  return del('/api/app/injuryPart/' + id, {}, {});
}

/**
 * 导出Excel
 * @param {*} id
 * @returns
 */
 export const ExportinjuryPart = (data) => {
  let defaluturl = `/api/app/injuryPart/exportExcelFile`;
  let fileName = "受伤类型"
  return download(fileName, defaluturl, data);
}